import { Injectable, inject, makeStateKey, TransferState } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SID } from '../interfaces';

@Injectable()
export class RasmusGuard {
  private readonly sid = inject(SID, { optional: true }) || '';
  constructor(private transferState: TransferState) {}

  async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const key = makeStateKey<string>('Site');
    if (this.transferState.hasKey(key)) {
      const sid = this.transferState.get<string>(key, null!);
      return sid === 'rasmus_auctions_appspot_com';
    }
    return this.sid === 'rasmus_auctions_appspot_com';
  }
}
